import Model from "../Model";

class ComercialUser extends Model{

    buildUrl ({ param }) {
        return ['zoneview/getbyuserid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new ComercialUser;